import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { id: "extensionBar" }
const _hoisted_2 = { class: "ng-extend-logo" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-symbols-outlined",
  style: {"font-size":"16px","vertical-align":"middle"}
}, "forum", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "nge-ask-label" }, "AI", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "nge-dataset-species"
}
const _hoisted_10 = {
  key: 1,
  class: "material-symbols-outlined",
  style: {"font-size":"16px","vertical-align":"middle"}
}
const _hoisted_11 = { class: "nge-dataset-label" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  id: "insertNGTopBar",
  class: "flex-fill"
}, null, -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "nge-share-toast"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "nge-share-toast-icon" }, [
  /*#__PURE__*/_createCommentVNode(" Back neuron (offset up-left) "),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-share-neuron nge-share-neuron--back",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("filter", {
        id: "shareNeuronGlow",
        x: "-40%",
        y: "-40%",
        width: "180%",
        height: "180%"
      }, [
        /*#__PURE__*/_createElementVNode("feGaussianBlur", {
          in: "SourceGraphic",
          stdDeviation: "0.7",
          result: "b1"
        }),
        /*#__PURE__*/_createElementVNode("feGaussianBlur", {
          in: "SourceGraphic",
          stdDeviation: "2",
          result: "b2"
        }),
        /*#__PURE__*/_createElementVNode("feMerge", null, [
          /*#__PURE__*/_createElementVNode("feMergeNode", { in: "b2" }),
          /*#__PURE__*/_createElementVNode("feMergeNode", { in: "b1" }),
          /*#__PURE__*/_createElementVNode("feMergeNode", { in: "SourceGraphic" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("radialGradient", {
        id: "shareSomaGrad",
        cx: "50%",
        cy: "50%",
        r: "50%"
      }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#80f0ff",
          "stop-opacity": "1"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "60%",
          "stop-color": "#20d0ff",
          "stop-opacity": "0.8"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#00a0e0",
          "stop-opacity": "0.2"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", { filter: "url(#shareNeuronGlow)" }, [
      /*#__PURE__*/_createCommentVNode(" Apical trunk + tuft "),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 30 L29 22 L27 14 L24 6",
        stroke: "#18cfff",
        "stroke-width": "1.6",
        "stroke-linecap": "round",
        opacity: "0.85"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L33 10 L40 7",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.7"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L21 10 L14 8",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.7"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L20 2",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L28 2",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createCommentVNode(" Basal dendrites "),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L24 38 L18 44",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L36 38 L42 44",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L30 42 L30 52",
        stroke: "#10b8e8",
        "stroke-width": "0.9",
        "stroke-linecap": "round",
        opacity: "0.55"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M18 44 L14 50",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.4"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M42 44 L46 50",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.4"
      }),
      /*#__PURE__*/_createCommentVNode(" Soma "),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "30",
        cy: "30",
        r: "4",
        fill: "url(#shareSomaGrad)"
      })
    ])
  ]),
  /*#__PURE__*/_createCommentVNode(" Front neuron (offset down-right, brighter) "),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-share-neuron nge-share-neuron--front",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { filter: "url(#shareNeuronGlow)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 30 L29 22 L27 14 L24 6",
        stroke: "#5be3ff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        opacity: "1"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L33 10 L40 7",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.85"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L21 10 L14 8",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.85"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L20 2",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L28 2",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L24 38 L18 44",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.8"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L36 38 L42 44",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.8"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L30 42 L30 52",
        stroke: "#3acaee",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.7"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M18 44 L14 50",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M42 44 L46 50",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "30",
        cy: "30",
        r: "4.5",
        fill: "url(#shareSomaGrad)"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "nge-share-toast-text" }, "Link copied to clipboard", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 8h3l2-2.5h8L18 8h3v11H3z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13.5",
    r: "3.8"
  })
], -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.5 6.5l8.5 6.5 8.5-6.5" })
], -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17.5 3h3.2l-7 8 8.2 10h-6.4l-5-6.5L4.7 21H1.5l7.5-8.5L1.2 3h6.6l4.5 6zm-1.1 16.2h1.8L7.7 4.7H5.8z" })
], -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 7h3V4h-3c-1.93 0-3.5 1.57-3.5 3.5V10H8v3h2.5v8h3v-8H16l1-3h-3.5V7.5c0-.28.22-.5.5-.5z" })
], -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  key: 2,
  class: "nge-toolbar-icons"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  width: "19",
  height: "19",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#dfe6f2",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12.5"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "16"
  })
], -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["data-icon-id", "title", "onDragstart", "onDragover", "onDragleave", "onDrop", "onClick"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  width: "19",
  height: "19",
  viewBox: "0 0 24 24",
  fill: "white",
  style: {"vertical-align":"middle"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "8",
  r: "4"
}, null, -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("path", { d: "M20 21c0-4.4-3.6-8-8-8s-8 3.6-8 8" }, null, -1 /* HOISTED */)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "🧭 Take the Site Tour", -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "Reset Tutorial 1", -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "Reset Tutorial 2", -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "Reset Tutorial 3", -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "Reset Site Tour", -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "Advanced Interface Tutorial", -1 /* HOISTED */)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "Cut & Merge Tutorial", -1 /* HOISTED */)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "logoutButton button" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("a", {
        target: "_blank",
        href: "https://forum.eyewire.org"
      }, "Forum")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "logoutButton button" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("a", {
        target: "_blank",
        href: "https://blog.pyr.ai/2024/12/20/proofreading-101-climb-into-spelunker/"
      }, "Proofreading Guide")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "logoutButton button" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("a", {
        target: "_blank",
        href: "https://youtu.be/48GS9Sizrvw"
      }, "Merge")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "logoutButton button" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("a", {
        target: "_blank",
        href: "https://youtu.be/DB6wmQWGsck"
      }, "Split")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "logoutButton button" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("a", {
        target: "_blank",
        href: "https://youtu.be/CGooeAhSryg"
      }, "Find path")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { id: "ngFarRight" }, null, -1 /* HOISTED */)
const _hoisted_59 = {
  key: 0,
  class: "nge-mobile-nav"
}
const _hoisted_60 = { class: "nge-mnav-icon" }
const _hoisted_61 = ["src"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Cells", -1 /* HOISTED */)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "💬", -1 /* HOISTED */)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Chat", -1 /* HOISTED */)
const _hoisted_65 = {
  key: 0,
  class: "nge-mnav-badge"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "📍", -1 /* HOISTED */)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Tags", -1 /* HOISTED */)
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "🔔", -1 /* HOISTED */)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Alerts", -1 /* HOISTED */)
const _hoisted_71 = {
  key: 0,
  class: "nge-mnav-badge"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "✨", -1 /* HOISTED */)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Guide", -1 /* HOISTED */)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_visible = _resolveDirective("visible")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["LoginModal"]),
    _createCommentVNode(" <annotation-panel /> "),
    _createCommentVNode(" Hidden: users pick cells from Cell Library instead "),
    _createVNode($setup["AchievementToast"]),
    _createVNode($setup["CommandPalette"], {
      ref: "cmdPalette",
      onOpenProfile: _cache[0] || (_cache[0] = $event => ($setup.showProfile = true)),
      onOpenRecap: _cache[1] || (_cache[1] = $event => ($setup.openWeekRecap())),
      onOpenLeaderboard: _cache[2] || (_cache[2] = $event => ($setup.showLeaderboard = true)),
      onOpenSettings: _cache[3] || (_cache[3] = $event => {$setup.profileInitialTab = 'settings'; $setup.showProfile = true}),
      onOpenHelp: _cache[4] || (_cache[4] = $event => {$setup.cellLibraryInitialTab = 'help'; $setup.showCellLibrary = true}),
      onOpenQueue: _cache[5] || (_cache[5] = $event => ($setup.showQueue = true)),
      onOpenCells: _cache[6] || (_cache[6] = $event => ($setup.showCellLibrary = true)),
      onOpenFeed: _cache[7] || (_cache[7] = $event => ($setup.showFeed = true)),
      onOpenDatasetSelector: _cache[8] || (_cache[8] = $event => ($setup.showDatasetSelector = true))
    }, null, 512 /* NEED_PATCH */),
    ($setup.showFeed)
      ? (_openBlock(), _createBlock($setup["ActivityFeedPanel"], {
          key: 0,
          onHide: _cache[9] || (_cache[9] = $event => ($setup.showFeed = false))
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Help requests now live in Cell Library's Help tab "),
    ($setup.showQueue)
      ? (_openBlock(), _createBlock($setup["ProofreadingQueuePanel"], {
          key: 1,
          onHide: _cache[10] || (_cache[10] = $event => ($setup.showQueue = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showCellLibrary)
      ? (_openBlock(), _createBlock($setup["CellLibraryPanel"], {
          key: 2,
          "initial-tab": $setup.cellLibraryInitialTab,
          onHide: _cache[11] || (_cache[11] = $event => {$setup.showCellLibrary = false; $setup.cellLibraryInitialTab = undefined})
        }, null, 8 /* PROPS */, ["initial-tab"]))
      : _createCommentVNode("v-if", true),
    ($setup.showBatchProcessor)
      ? (_openBlock(), _createBlock($setup["BatchProcessorPanel"], {
          key: 3,
          onHide: _cache[12] || (_cache[12] = $event => ($setup.showBatchProcessor = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showTagMode)
      ? (_openBlock(), _createBlock($setup["TagModePanel"], {
          key: 4,
          onHide: _cache[13] || (_cache[13] = $event => ($setup.showTagMode = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showFlightMode)
      ? (_openBlock(), _createBlock($setup["FlightMode"], {
          key: 5,
          onHide: _cache[14] || (_cache[14] = $event => ($setup.showFlightMode = false))
        }))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createVNode($setup["VolumesOverlay"], {
      onHide: _cache[15] || (_cache[15] = $event => ($setup.showModal = false))
    }, null, 512 /* NEED_PATCH */), [
      [_directive_visible, $setup.showModal]
    ]),
    ($setup.showDatasetSelector)
      ? (_openBlock(), _createBlock($setup["DatasetSelectorPanel"], {
          key: 6,
          onHide: _cache[16] || (_cache[16] = $event => ($setup.showDatasetSelector = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showProfile)
      ? (_openBlock(), _createBlock($setup["UserProfilePanel"], {
          key: 7,
          "view-user-id": $setup.profileUserId,
          "initial-tab": $setup.profileInitialTab,
          onHide: _cache[17] || (_cache[17] = $event => {$setup.showProfile = false; $setup.profileUserId = null; $setup.profileInitialTab = undefined}),
          onOpenSettings: _cache[18] || (_cache[18] = $event => {$setup.profileInitialTab = 'settings'; $setup.showProfile = true})
        }, null, 8 /* PROPS */, ["view-user-id", "initial-tab"]))
      : _createCommentVNode("v-if", true),
    ($setup.showFeedback)
      ? (_openBlock(), _createBlock($setup["FeedbackModal"], {
          key: 8,
          onHide: _cache[19] || (_cache[19] = $event => ($setup.showFeedback = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showLeaderboard)
      ? (_openBlock(), _createBlock($setup["LeaderboardPanel"], {
          key: 9,
          onHide: _cache[20] || (_cache[20] = $event => ($setup.showLeaderboard = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showSettings)
      ? (_openBlock(), _createBlock($setup["SettingsPanel"], {
          key: 10,
          onHide: _cache[21] || (_cache[21] = $event => ($setup.showSettings = false))
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["NotificationFeedPanel"], {
      visible: $setup.showNotifications,
      onHide: _cache[22] || (_cache[22] = $event => ($setup.showNotifications = false)),
      onOpenHelp: _cache[23] || (_cache[23] = $event => {$setup.cellLibraryInitialTab = 'help'; $setup.showCellLibrary = true})
    }, null, 8 /* PROPS */, ["visible"]),
    ($setup.showChat)
      ? (_openBlock(), _createBlock($setup["ChatPanel"], {
          key: 11,
          onHide: _cache[24] || (_cache[24] = $event => ($setup.showChat = false))
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" The Ask dock is now the single command surface: it searches the same\n       catalog CommandPalette builds (passed in headless) so navigation runs\n       instantly, and only falls through to the model for real questions. "),
    _createCommentVNode(" Self-contained: listens for nge:prompt-username (fired after Tutorial 1)\n       and no-ops if the user already has a handle or dismissed it before. "),
    _createVNode($setup["UsernamePrompt"]),
    _createVNode($setup["AssistantDock"], {
      show: $setup.showAssistant,
      "ui-state": $setup.assistantUiState,
      "search-commands": $setup.searchCommands,
      "run-command-by-id": $setup.runCommandById,
      onHide: _cache[25] || (_cache[25] = $event => ($setup.showAssistant = false))
    }, null, 8 /* PROPS */, ["show", "ui-state"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode(" Click → hard refresh. Reloads the bundle from the server (skips\n           the disk cache so a freshly-deployed JS hits the user without a\n           manual Ctrl+F5). Tour step #2 explains this. "),
        _createElementVNode("a", {
          href: "#",
          title: "EyeWire II — click to hard refresh",
          onClick: _withModifiers($setup.hardRefresh, ["prevent"])
        }, [
          _createElementVNode("img", {
            src: $setup.pyrIcon,
            class: "nge-pyr-logo"
          }, null, 8 /* PROPS */, _hoisted_4)
        ], 8 /* PROPS */, _hoisted_3)
      ]),
      _createCommentVNode(" AI guide + Dataset live on the left edge (Amy 2026-08-17). "),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-ask-btn", { 'nge-ask-btn--active': $setup.showAssistant }]),
        onClick: _cache[26] || (_cache[26] = $event => ($setup.showAssistant = !$setup.showAssistant)),
        title: "Nurro, your guide"
      }, _hoisted_7, 2 /* CLASS */),
      _createElementVNode("button", {
        class: "nge-dataset-btn",
        onClick: _cache[27] || (_cache[27] = $event => ($setup.showDatasetSelector = !$setup.showDatasetSelector)),
        title: 'Current dataset: ' + $setup.currentDatasetName + ' — click to switch'
      }, [
        ($setup.currentDatasetIcon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.currentDatasetIcon), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, "database")),
        _createElementVNode("span", _hoisted_11, _toDisplayString($setup.currentDatasetAbbrev), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_8),
      _hoisted_12,
      _createVNode(_Transition, { name: "nge-share-toast" }, {
        default: _withCtx(() => [
          ($setup.shareCopied)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("div", { class: "nge-share-toast-actions" }, [
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Save screenshot",
                    onClick: $setup.shareActionScreenshot
                  }, _hoisted_17),
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Email link",
                    onClick: $setup.shareActionEmail
                  }, _hoisted_19),
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Post to X",
                    onClick: $setup.shareActionX
                  }, _hoisted_21),
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Share to Facebook",
                    onClick: $setup.shareActionFacebook
                  }, _hoisted_23)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["ScreenshotDialog"], {
        show: $setup.showScreenshotDialog,
        onClose: _cache[28] || (_cache[28] = $event => ($setup.showScreenshotDialog = false))
      }, null, 8 /* PROPS */, ["show"]),
      ($setup.volumes.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[29] || (_cache[29] = $event => ($setup.showModal = true))
          }, "Volumes (" + _toDisplayString($setup.volumes.length) + ")", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0 && $setup.stats.currentStreak > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "nge-streak-chip",
            title: `Editing streak: ${$setup.stats.currentStreak} day${$setup.stats.currentStreak === 1 ? '' : 's'} in a row with at least one edit`
          }, " 🔥 " + _toDisplayString($setup.stats.currentStreak), 9 /* TEXT, PROPS */, _hoisted_24))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "nge-icon-btn nge-feedback-btn",
              title: "Submit an issue or feedback",
              onClick: _cache[30] || (_cache[30] = $event => ($setup.showFeedback = true))
            }, _hoisted_27),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleToolbar, (icon) => {
              return (_openBlock(), _createElementBlock("button", {
                key: icon.id,
                "data-icon-id": icon.id,
                class: _normalizeClass(["nge-icon-btn", {
          'nge-icon-btn--badge': icon.badge && icon.badge() > 0,
          'nge-icon-btn--active': $setup.isIconActive(icon.id),
          'nge-icon-btn--dragging': $setup.dragId === icon.id,
          'nge-icon-btn--drag-over': $setup.dragOverId === icon.id && $setup.dragId !== icon.id,
        }]),
                title: icon.label + ' — drag to reorder',
                draggable: "true",
                onDragstart: $event => ($setup.onIconDragStart($event, icon.id)),
                onDragend: $setup.onIconDragEnd,
                onDragover: $event => ($setup.onIconDragOver($event, icon.id)),
                onDragleave: $event => ($setup.onIconDragLeave(icon.id)),
                onDrop: $event => ($setup.onIconDrop($event, icon.id)),
                onClick: $event => (icon.action())
              }, [
                (icon.svg)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: icon.svg
                    }, null, 8 /* PROPS */, _hoisted_29))
                  : (icon.img)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: icon.img,
                        class: "nge-toolbar-icon-img"
                      }, null, 8 /* PROPS */, _hoisted_30))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(icon.emoji), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */)),
                (icon.badge && icon.badge() > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: _normalizeClass(["nge-toolbar-badge", { 'nge-toolbar-badge--chat': icon.id === 'chat' }])
                    }, _toDisplayString(icon.badge()), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_28))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "nge-icon-btn",
            onClick: _cache[31] || (_cache[31] = $event => {$setup.profileUserId = null; $setup.showProfile = true}),
            id: "profileBtn",
            title: "My Profile",
            style: {"margin-left":"12px","margin-right":"14px"}
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_34))
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["DropdownList"], {
        "dropdown-group": "extension-bar-right",
        id: "hamburger",
        class: "rightMost",
        title: "Resources and tutorials"
      }, {
        buttonTitle: _withCtx(() => [
          _createElementVNode("span", { innerHTML: $setup.RESOURCES_MENU_SVG }, null, 8 /* PROPS */, _hoisted_35)
        ]),
        listItems: _withCtx(() => [
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-tour-btn",
              onClick: _cache[32] || (_cache[32] = $event => {$setup.tutorialStore.activeTutorial = 4; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
            }, _hoisted_37)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button",
              onClick: _cache[33] || (_cache[33] = $event => {$setup.tutorialStore.activeTutorial = 1; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
            }, _hoisted_39)
          ]),
          ($setup.tutorialStore.tutorialStep2 >= 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                _createElementVNode("div", {
                  class: "logoutButton button",
                  onClick: _cache[34] || (_cache[34] = $event => {$setup.tutorialStore.activeTutorial = 2; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
                }, _hoisted_42)
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.tutorialStore.tutorialStep3 >= 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                _createElementVNode("div", {
                  class: "logoutButton button",
                  onClick: _cache[35] || (_cache[35] = $event => {$setup.tutorialStore.activeTutorial = 3; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
                }, _hoisted_45)
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.tutorialStore.tutorialStep4 >= 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                _createElementVNode("div", {
                  class: "logoutButton button",
                  onClick: _cache[36] || (_cache[36] = $event => {$setup.tutorialStore.activeTutorial = 4; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
                }, _hoisted_48)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button",
              onClick: _cache[37] || (_cache[37] = $event => {$setup.tutorialStore.activeTutorial = 2; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
            }, _hoisted_50)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button",
              onClick: _cache[38] || (_cache[38] = $event => {$setup.tutorialStore.activeTutorial = 3; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
            }, _hoisted_52)
          ]),
          _hoisted_53,
          _hoisted_54,
          _createCommentVNode("\n          TODO: User reports Merge (48GS9Sizrvw) and Split (DB6wmQWGsck) videos\n          are unreachable for them while Find path (CGooeAhSryg) works. URLs\n          return HTTP 200 but may be unlisted/region-restricted. Verify with the\n          EyeWire YouTube channel and replace if needed.\n        "),
          _hoisted_55,
          _hoisted_56,
          _hoisted_57
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Far-right slot: mergeTopBars() relocates NG's ? (help) and the\n         layer side panel toggle here, toggle last so it hugs the panel it\n         opens (Amy 2026-08-17). "),
      _hoisted_58
    ]),
    _createCommentVNode(" ── Mobile only: welcome sheet + bottom nav (util/mobile.ts) ───────── "),
    _createCommentVNode(" logged-in gates the Guide's link mode on VALID sessions only: a stale\n       token in localStorage must not hide the Log in button (Amy: the\n       landing pop-up needs login until you are actually in). "),
    ($setup.isMobileRef)
      ? (_openBlock(), _createBlock($setup["MobileWelcome"], {
          key: 12,
          show: $setup.showMobileWelcome,
          "logged-in": $setup.validLogins.length > 0,
          "login-checked": $setup.login.checked,
          "user-name": $setup.validLogins[0]?.name,
          onHide: $setup.exploreWithoutLogin,
          onLogin: $setup.mobileWelcomeLogin,
          onTour: $setup.startMobileTour,
          onOpen: $setup.mobileOpenPanel
        }, null, 8 /* PROPS */, ["show", "logged-in", "login-checked", "user-name"]))
      : _createCommentVNode("v-if", true),
    ($setup.isMobileRef)
      ? (_openBlock(), _createBlock($setup["MobileTour"], {
          key: 13,
          show: $setup.showMobileTour,
          "logged-in": $setup.validLogins.length > 0,
          onFinish: _cache[39] || (_cache[39] = $event => ($setup.showMobileTour = false))
        }, null, 8 /* PROPS */, ["show", "logged-in"]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.isMobileRef)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_59, [
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showCellLibrary }),
              "data-mnav": "cells",
              onClick: _cache[40] || (_cache[40] = $event => ($setup.mobileNavTap('cells')))
            }, [
              _createElementVNode("span", _hoisted_60, [
                _createElementVNode("img", {
                  src: $setup.neuronIcon,
                  class: "nge-mnav-neuron",
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_61)
              ]),
              _hoisted_62
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showChat }),
              "data-mnav": "chat",
              onClick: _cache[41] || (_cache[41] = $event => ($setup.mobileNavTap('chat')))
            }, [
              _hoisted_63,
              _hoisted_64,
              ($setup.chatStore.unreadCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString($setup.chatStore.unreadCount), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showTagMode }),
              "data-mnav": "tags",
              onClick: _cache[42] || (_cache[42] = $event => ($setup.showTagMode = !$setup.showTagMode))
            }, _hoisted_68, 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showNotifications }),
              "data-mnav": "alerts",
              onClick: _cache[43] || (_cache[43] = $event => ($setup.showNotifications = !$setup.showNotifications))
            }, [
              _hoisted_69,
              _hoisted_70,
              ($setup.backendStore.unreadNotificationCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString($setup.backendStore.unreadNotificationCount), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showMobileWelcome }),
              "data-mnav": "guide",
              onClick: _cache[44] || (_cache[44] = $event => ($setup.showMobileWelcome = true))
            }, _hoisted_74, 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}